import { IProductTile } from '@models/IProductTile';
import AddToMyListButton from '@molecules/AddToMyListButton/AddToMyListButton';
import ProductTile from '@organisms/ProductTile/ProductTile';
import { WishlistButtonContext } from '@utility/context/WishlistButtonContext';

const ProductTileWrapper = (props: IProductTile) => (
  <WishlistButtonContext value={AddToMyListButton}>
    <ProductTile {...props} />
  </WishlistButtonContext>
);

export default ProductTileWrapper;
